// extracted by mini-css-extract-plugin
module.exports = {"borderfull":"AnchorsPortfolio_borderfull__QPPg9"};